<div class="preview">
    <div class="preview__header">
        <h3 class="text-base--primary">Preview Contents</h3>
        <p class="text-description">View and interact with the selected media items.</p>
    </div>

    <div class="preview__contents">
        <p class="preview__count">Count: {{ selectedItems().length }}</p>
        <div class="preview__contents-grid grid-contents grid-contents--5">
            @for (item of selectedItems(); track item.id) {
                <div class="ntv-thumbnail-item--wrapper">
                    <ntv-thumbnail-item
                        [disableRightClick]="true"
                        [item]="item"
                        size="md"
                        [customWidth]="'100%'"
                        [customTextSize]="'12px'"
                        [showActionButtons]="false"
                        [showThumbnailInfoTag]="false"
                        [eyeIconVisible]="false" />
                    <button
                        class="ntv-thumbnail-item--wrapper__remove-btn"
                        (click)="onRemoveItem(item.id)"
                        title="Remove selected item">
                        <svg class="icon" width="14" height="14">
                            <use xlink:href="assets/icons/icons-sprite.svg#close" />
                        </svg>
                    </button>
                </div>
            }
        </div>
    </div>
</div>
